import { render, staticRenderFns } from "./TaxInvoiceMakung.vue?vue&type=template&id=0484f612&scoped=true&"
import script from "./TaxInvoiceMakung.vue?vue&type=script&lang=js&"
export * from "./TaxInvoiceMakung.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=0484f612&scoped=true&lang=css&"
import style1 from "./TaxInvoiceMakung.vue?vue&type=style&index=1&id=0484f612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484f612",
  null
  
)

export default component.exports